/**
 * @typedef {{product: Object, quantity: number, options: number[][]}} ProductItem
 */

const { createApp, ref } = Vue;

let loggerDebug = false;

function logger(...data) {
    if (loggerDebug) console.log(...data);
}

// 问题的值的映射表

const answers = [
    // q1
    [
        "26SCOutdoor",
        "26SCIndoor",
        "26SCAll",
        "26SCOther",
    ],
    //q2 (for q1-a)
    [
        "Lawn1000",
        "Lawn1500",
        "Lawn3000",
        "Lawn3000+"
    ],
    //q3 (for q1-a)
    [
        "WasteTime",
        "Noise",
        "NotSmart",
        "MissedEdges",
        "HighCost"
    ],
    //q4 (for q1-b)
    [
        "DeepClean",
        "Maintenance",
        "PetCare",
        "Coverage",
    ],
    //q5 (for q1-b)
    [
        "Upgrade",
        "Dissatisfied",
        "Exploring",
        "Browsing",
    ]
]

// 针对问题1 的D选项的延伸多选值的映射表
const categories = ["个护", "厨电", "空净"];


// klaviyo接口数据

// 这两个ID需要客户提供，从klaviyo后台可以找到
let companyId = 'XnnEKs';
let listId = "T3uMEw";

// localStorage Key
let storage_key = 'shopGuide_giftEmailSent';

const url = `https://a.klaviyo.com/client/subscriptions?company_id=${companyId}`;

const body = {
    data: {
        type: 'subscription',
        attributes: {
            profile: {
                data: {
                    type: 'profile',
                    attributes: {
                        subscriptions: {
                            email: {
                                marketing: {
                                    consent: 'SUBSCRIBED',
                                },
                            },
                        },
                        email: "111@qq.com",
                        properties: {
                            services: '{"shopify":{"source":"form"}}',
                            $timezone_offset: 8,
                        },
                    },
                },
            },
        },
        relationships: {
            list: {
                data: {
                    type: 'list',
                    id: listId,
                },
            },
        },
    },
};


let shopGuideVue = new Vue({
    el: '.main-shop-guide',
    delimiters: ['${', '}'],
    data() {
        return {
            currentStep: 1,
            totalStep: 3,
            originalQuestionList: [], // 备份原始问题数据
            questionList: [
                {
                    question: "How interested are you in the detector?",
                    questionSmallText: "(Multiple choice)",
                    options: [
                        "Smoke and fire",
                        "Carbon monoxide poisoning",
                        "Gas Leak",
                        "Abnormal temperature",
                        "Video surveillance",
                    ],
                    multipleChoose: true,
                },
                {
                    question: "How interested are you in the detector?",
                    options: [
                        "After installing, I won't pay attention.",
                        "likeDIY",
                        "I am often not at home and need to control it through my mobile phone.",
                    ],
                    multipleChoose: false,
                },
                {
                    question: "How interested are you in the detector?",
                    options: [
                        "After installing, I won't pay attention.",
                        "likeDIY",
                        "I am often not at home and need to control it through my mobile phone.",
                    ],
                    multipleChoose: false,
                }
            ],
            // 翻译文案
            productTranslate: {},
            /** @type {ProductItem} */
            productList: [
                {
                    product: {},
                    options: [[0], [], []],
                }
            ],
            /** @type {ProductItem} */
            resultProducts: [],
            // 已选项（单选、多选的索引）
            chooseIndexOptions: [
                // [0], [0], [0]
            ],
            // 子选项列表
            areaOptions: [],
            // 子选项在哪个问题出现
            areaForQuestionNumber: 1,
            // 子选项的索引
            selectedAreaOptionIndex: [

            ],
            addToCartLoading: false,
            giftEmail: undefined,
            isAgreePolicy: false,
            subscribed: false,
            policyChecked: true,

            subscribedBefore: false,

        }
    },
    computed: {
        isShowResult() {
            return this.currentStep > this.totalStep;
        },
        // 选择的面积对应的产品 Quantity
        selectQuantity() {
            // return this.areaOptions[this.selectedAreaOptionIndex].settings.quantity;
        },
    },
    beforeMount() {
        this.initData();
        // this.IsSubcribedBefore();
    },
    mounted() {
        this.setSameHeight();
    },
    watch: {
        currentStep(step) {
            if (step > this.totalStep) {
                this.takeResultProducts();
            }
        },
        isAgreePolicy(newVal) {
            this.policyChecked = !!newVal;
        }

    },
    methods: {
        // 初始化数据
        initData() {

            // 问题、选项数据
            const mainScript = document.querySelector(`script[data-shop-guide-main]`);
            const mainScriptJson = JSON.parse(mainScript.innerHTML);
            this.areaForQuestionNumber = mainScriptJson.area_for_question_number;

            const questionsJson = mainScriptJson.blocks.filter((v) => v.type == 'question' || v.type == 'gift_card');
            this.totalStep = questionsJson.length;
            this.questionList = [];

            // Questions
            for (const item of questionsJson) {
                const questionObject = {
                    question: item.settings.question,
                    questionSmallText: item.settings.question_small_text,
                    multipleChoose: item.settings.multiple_choice,
                    options: [],
                    // 以下两个属性用来标记子问题
                    isChildQuestion: item.settings.is_child_question,
                    parentQuestionIndex: +item.settings.parent_question_index,
                    type: item.type,
                    // 以下属性针对奖励
                    giftParentsQuestionIndex: +item.settings.parent_question_index_for_gift,
                    giftImageUrlPc: item.settings.gift_image_pc,
                    giftImageUrlMobile: item.settings.gift_image_mobile,
                    giftImageExtraInfo: item.settings.extra_info_on_image,
                    giftTile: item.settings.gift_title,
                    giftDesc: item.settings.gift_desc,
                    giftEamilPlaceholder: item.settings.gift_email_placeholder,
                    giftEmailLabel: item.settings.gift_button_label,
                    giftEmallPolicyText: item.settings.gift_email_policy,
                    giftEmailSuccessText: item.settings.gift_email_success_text,
                };
                for (let i = 1; i <= 10; i++) {
                    const key = `option_${i}`;
                    const value = item.settings[key];
                    if (value != null && value != '') questionObject.options.push(value);
                }
                this.questionList.push(questionObject);
                this.originalQuestionList.push(questionObject); // 备份原始问题数据
            }
            // Area options
            const areaOptionsJson = mainScriptJson.blocks.filter((v) => v.type == 'area_option');
            this.areaOptions = areaOptionsJson;



        },

        IsSubcribedBefore() {
            const localInfo = localStorage.getItem("shopGuide_giftEmailSent");
            if (localInfo) {
                const info = JSON.parse(localInfo);
                const q1Index = info.q1;
                this.chooseIndexOptions[this.currentStep - 1] = [q1Index];
                this.handleClickOption(_, q1Index);
                this.currentStep = this.totalStep;
                this.subscribed = true;
                this.subscribedBefore = true;
            }
        },

        setSameHeight() {
            const els = document.querySelectorAll('.shop-guide__choosing-item');

            if (!els.length) return;

            els.forEach(el => el.style.height = 'auto');
            let max = 0;
            els.forEach(el => {
                const h = el.getBoundingClientRect().height;
                if (h > max) max = h;
            });
            els.forEach(el => el.style.height = `${max}px`);
        },

        /**
         * 上一步
         */
        handleClickPrevious() {
            if (this.currentStep > 1) {
                this.currentStep--;
                this.chooseIndexOptions.pop();
                // 等Vue渲染完UI后再处理高度
                setTimeout(() => {
                    this.setSameHeight();
                }, 0)
            } else {
                this.currentStep = 1;
            }
        },
        /**
         * 下一步
         */
        handleClickNextStep() {
            if (this.currentStep <= this.totalStep) {
                this.currentStep++;
                setTimeout(() => {
                    this.setSameHeight();
                }, 0)
            } else {
                this.currentStep = this.totalStep;
            }
        },
        /**
         * 重置
         */
        handleClickReset() {
            this.currentStep = 1;
            this.chooseIndexOptions = [];
        },
        /**
         * 点击选项
         */
        handleClickOption(_, index) {

            const stepIndex = this.currentStep - 1;
            const multipleChoose = this.questionList[stepIndex].multipleChoose;
            if (multipleChoose) {
                const set = new Set(this.chooseIndexOptions[stepIndex]);
                set.has(index) ? set.delete(index) : set.add(index);
                this.chooseIndexOptions[stepIndex] = [...set];
            } else {
                this.chooseIndexOptions[stepIndex] = [index];
            }
            this.chooseIndexOptions = [...this.chooseIndexOptions];

            // 针对第一个问题，开始分支子问题和奖励
            if (this.chooseIndexOptions.length < 2) {
                const childQuestionList = this.originalQuestionList.filter(v => v.isChildQuestion && v.parentQuestionIndex === this.chooseIndexOptions[0][0]);
                const giftCardList = this.originalQuestionList.filter(v => v.type === 'gift_card' && v.giftParentsQuestionIndex === this.chooseIndexOptions[0][0]);
                this.questionList = [this.originalQuestionList[0], ...childQuestionList, ...giftCardList];
                this.totalStep = this.questionList.length;
            }
            console.log(this.questionList)
            // console.log(this.chooseIndexOptions)
            // console.log(this.totalStep)
        },
        /**
         * 点击子选项
         */
        handleClickAreaOption(_, index) {
            const set = new Set(this.selectedAreaOptionIndex);
            set.has(index) ? set.delete(index) : set.add(index);
            this.selectedAreaOptionIndex = [...set];

        },
        getAnswerData() {
            if (!this.chooseIndexOptions.length) return;
            const firstQuestionIndex = this.chooseIndexOptions[0][0];

            let data = null;
            if (firstQuestionIndex === 0) {
                data = {
                    q1: answers[0][firstQuestionIndex],
                    q2_select_a: answers[1][this.chooseIndexOptions[1][0]],
                    q3_select_a: answers[2][this.chooseIndexOptions[2][0]]
                }
            } else if (firstQuestionIndex === 1) {
                data = {
                    q1: answers[0][firstQuestionIndex],
                    q2_select_b: answers[3][this.chooseIndexOptions[1][0]],
                    q3_select_b: answers[4][this.chooseIndexOptions[2][0]]
                }
            } else if (firstQuestionIndex === 2) {
                data = {
                    q1: answers[0][firstQuestionIndex]
                }
            } else {
                let other_categoryes = [];
                for (let i = 0; i < this.selectedAreaOptionIndex.length; i++) {
                    other_categoryes.push(categories[i])
                }

                data = {
                    q1: answers[0][firstQuestionIndex],
                    other_categoryes
                }
            }
            return data;
        },

        handleSendGiftCardEmail() {
            if (!this.isAgreePolicy) this.policyChecked = false
            else this.policyChecked = true
            if (!this.isAgreePolicy) return;
            let info = null;
            let recorded;
            if (this.giftEmail) {
                const localInfo = localStorage.getItem(storage_key);
                if (localInfo) {
                    info = JSON.parse(localInfo);
                    info.forEach(item => {
                        if (item.email == this.giftEmail) {
                            recorded = true;
                            this.subscribed = true;
                            this.subscribedBefore = recorded;
                        }
                    })
                }
            }

            if (recorded) return;

            const answerData = this.getAnswerData();
            body.data.attributes = {
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            subscriptions: {
                                email: {
                                    marketing: {
                                        consent: 'SUBSCRIBED',
                                    },
                                },
                            },
                            email: this.giftEmail,
                            properties: Object.assign(answerData, {
                                services: '{"shopify":{"source":"form"}}',
                                $timezone_offset: 8,
                            })
                        },
                    },
                }
            }
            const options = {
                method: 'POST',
                headers: {
                    revision: '2026-01-15',
                    accept: 'application/vnd.api+json',
                    'content-type': 'application/vnd.api+json'
                },
                body: JSON.stringify(body)
            };
            fetch(url, options)
                .then(res => {
                    if (res.status && res.status === 202) {
                        this.subscribed = true;
                        try {
                            if (info) {
                                info.push({
                                    email: this.giftEmail || null,
                                    timestamp: Date.now(),
                                    q1: this.chooseIndexOptions[0][0]
                                })
                                localStorage.setItem(storage_key, JSON.stringify(info));
                            } else {
                                localStorage.setItem(storage_key, JSON.stringify([
                                    {
                                        email: this.giftEmail || null,
                                        timestamp: Date.now(),
                                        q1: this.chooseIndexOptions[0][0]
                                    }
                                ]));
                            }
                        } catch (e) {
                            console.warn('Failed to write localStorage', e);
                        }
                    } else {
                        this.subscribed = false;
                    }
                }).catch(err => console.error(err));
        }



    }
});

